import { render, staticRenderFns } from "./TemplateCreationDialog.vue?vue&type=template&id=484d4f67&scoped=true"
import script from "./TemplateCreationDialog.vue?vue&type=script&lang=js"
export * from "./TemplateCreationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d4f67",
  null
  
)

export default component.exports